import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import {
  CryptoService,
  DataRefreshService,
  RoutingService,
} from '@shared/services';
import { ExceptionMessage, StaticMessage } from '@shared/enums';
import { Constants, getStaticMessage } from '@shared/utils';
import { ConfirmDialogComponent } from '@shared/components';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { tap } from 'rxjs';

@Injectable()
@UntilDestroy()
export class SaveErrorHandlerService {
  constructor(
    private dialog: MatDialog,
    private routingService: RoutingService,
    private cryptoService: CryptoService,
    private dataRefreshService: DataRefreshService
  ) {}

  public onSaveError(
    tabName: string,
    selectedSubProjectId: number,
    error: HttpErrorResponse
  ): void {
    switch (error.error?.exceptionMessage) {
      case ExceptionMessage.AdminNotificationSyncError: {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          ...Constants.DialogOptions,
          data: {
            title: getStaticMessage(StaticMessage.PartialSyncErrorTitle),
            message: getStaticMessage(StaticMessage.PartialSyncError, tabName),
            buttonLabel: getStaticMessage(StaticMessage.OkButton),
            hideCancelButton: true,
          },
        });

        dialogRef
          .afterClosed()
          .pipe(
            untilDestroyed(this),
            tap(() => {
              this.dataRefreshService.setRefreshNeeded();
            })
          )
          .subscribe();
        break;
      }
      case ExceptionMessage.LockedDpr: {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          ...Constants.DialogOptions,
          data: {
            title: getStaticMessage(StaticMessage.SyncErrorTitle),
            message: getStaticMessage(StaticMessage.LockedDprError, tabName),
            buttonLabel: getStaticMessage(StaticMessage.OkButton),
            hideCancelButton: true,
          },
        });

        dialogRef
          .afterClosed()
          .pipe(
            untilDestroyed(this),
            tap(() => {
              this.dataRefreshService.setRefreshNeeded();
              this.routingService.navigateToRoute(
                this.routingService.routePrefix,
                'dprs',
                this.cryptoService.encryptId(selectedSubProjectId)
              );
            })
          )
          .subscribe();
        break;
      }
      default: {
        this.dialog.open(ConfirmDialogComponent, {
          ...Constants.DialogOptions,
          data: {
            title: getStaticMessage(StaticMessage.SaveErrorTitle),
            message: getStaticMessage(StaticMessage.SaveErrorTryAgain),
            buttonLabel: getStaticMessage(StaticMessage.OkButton),
            hideCancelButton: true,
          },
        });
      }
    }
  }
}
